import axiox from './axios';
import {SET_CONTENTS_LOADING,SET_APPROVE_CONTENTS,SET_NEXT_CONTENTS,SET_APPROVE_CONTENT,GET_ERRORS} from './types'

export const setContentsApprove = () => dispatch => {
  dispatch(setContentsLoading());
  axiox
    .get('/api/contents/approve')
    .then(res =>
      dispatch({
        type: SET_APPROVE_CONTENTS,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const setContentApprove = (id) => dispatch => {
  axiox
    .post('/api/contents/approve',{id})
    .then(res => console.log(res.data)
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
}

export const setContents =(page) => dispatch => {
  dispatch(setContentsLoading());
  axiox
    .get('/api/contents/next/?pages='+page)
    .then(result => 
      dispatch({
        type:SET_NEXT_CONTENTS,
        payload:result.data
      }))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
}

export const postNews = (formdata) => dispatch => {
  for (var value of formdata.values()) {
    console.log("Value:"+value); 
 }
 
 axiox.post('/api/contents/new',formdata,{headers:{['content-type']:'multipart/form-data'}})
  .then(res => console.log(res))
}

export const setContentsLoading = () => {
  return {
    type: SET_CONTENTS_LOADING
  };
};


// WEBPACK FOOTER //
// ./src/actions/contentsActions.js